module.exports = __webpack_public_path__ + "img/vatm.775c0646.png";